import React, { useState } from 'react';
import '../Login/Login.css';
import { usePromiseTracker } from "react-promise-tracker";
import { Oval } from 'react-loading-icons'
import { confirmAlert } from 'react-confirm-alert';

export default function Loginf() {
    localStorage.clear();
    const backgroundImage = `/principal/fondo15.jpg`;
    const { promiseInProgress } = usePromiseTracker(); 
    const mensaje = (respuesta) =>{
        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui center-text'>
                  <center><h3>{respuesta}</h3></center>
                  <center>
                  <button
                      className="button-modal-single"
                      onClick={() => {
                        onClose();
                      }}
                    >
                      Aceptar
                    </button>   
                    </center>         
                </div>
              );
            }
          });
    } 

    function login() {
      mensaje("Las votaciones estarán habilitadas el día de la asamblea.");
    }
    
    return(
      <div>
            <div className="main other-component login-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
                <div className="login-wrapper login-padding">
                    <div className='login-style'>
                        <div>
                        <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo_login" alt="Guadalupana"></img>
                        </div>
                <label>
                      <div className="login-label">CUI</div>
                      <input className="input" placeholder="CUI" type="number" />
                  </label>
                  <label>
                      <div className="login-label">Contraseña</div>
                      <input className="input" placeholder="Contraseña" />
                  </label>
                <div>
                    <button className="button" onClick={ login } disabled={ promiseInProgress ? "disabled" : "" } > 
                        { promiseInProgress ? "Iniciando..." : "Iniciar sesión"} 
                        { promiseInProgress && <Oval className="loading-icon" /> }
                    </button>
                </div>
             </div>
        </div>
        </div>
    </div>
    )
}

